import React, {Component} from 'react';
import PropTypes from 'prop-types';
import RichText from '../../Util/RichText';
import {FormattedMessage} from 'react-intl';

const MessageAsAttributeTable = ({body, copyTable}) => (
    <div>
        <div id="attribute-table" style={{width: 'auto'}}>
            <table width="100%" className="attributes-table table table-sm">
                <tbody>
                    <tr>
                        <th style={{width: '30%'}}><FormattedMessage id="thread.message"/></th>
                        <td style={{width: '70%'}}><div><RichText content={body}/></div></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div className="attributes-button-section">
            <button onClick={copyTable} className="btn btn-sm btn-primary">
                <span className="fas fa-list-alt"/> <FormattedMessage id="attributes_table.copy"/>
            </button>
        </div>
        <div className="attribute-table-print">
            <div id="attribute-table-print" style={{width: 'auto'}}>
                <table width="100%" className="attributes-table table table-sm" style={{border: '1px solid white', background: '#f9f5f6', color: '#4b4a5c'}}>
                    <tbody>
                        <tr>
                            <th style={{width: '30%', background: '#cdc7b9'}}><FormattedMessage id="thread.message"/></th>
                            <td style={{width: '70%'}}><div><RichText content={body}/></div></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
);

class MessageAsAttribute extends Component {
    constructor() {
        super();
        this.copyTable = this.copyTable.bind(this);
    }

    render() {
        return (
            <div className="media-body">
                <MessageAsAttributeTable body={this.props.body} copyTable={this.copyTable}/>
            </div>
        );
    }

    copyTable() {
        selectElementContents(document.getElementById('attribute-table-print'));
        document.execCommand('copy');
    }
}

MessageAsAttribute.propTypes = {
    body: PropTypes.string.isRequired,
};

const selectElementContents = (el) => {
    let body = document.body, range, sel;

    if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
            range.selectNodeContents(el);
            sel.addRange(range);
        } catch (e) {
            range.selectNode(el);
            sel.addRange(range);
        }
    } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
    }
};

export default MessageAsAttribute;
